<template>
  <div>
    <template v-if="['ADMIN', 'ASSISTANT'].includes($store.state.profile.role)">
      <CloudFolderPermission v-model="dialogPermissions" :address="address" />
      <ChangeName v-model="dialog" :address="address" />
      <DeleteAddress
        v-model="dialogDelete"
        :address="address"
        @delete-address="$emit('delete-address', $event)"
      />
    </template>
    <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
      <v-list dense width="300">
        <v-list-item @click="dialogPermissions = true">
          <v-list-item-title> Permissions </v-list-item-title>
          <v-list-item-icon>
            <v-icon> mdi-account-lock </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item @click="dialog = true">
          <v-list-item-title> Rename </v-list-item-title>
          <v-list-item-icon>
            <v-icon> mdi-pencil </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item @click="dialogDelete = true">
          <v-list-item-title class="error--text"> Delete </v-list-item-title>
          <v-list-item-icon>
            <v-icon color="error"> mdi-delete </v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import ChangeName from "./ChangeName.vue";
import CloudFolderPermission from "./CloudFolderPermission.vue";
import DeleteAddress from "./DeleteAddress.vue";

export default {
  components: { ChangeName, DeleteAddress, CloudFolderPermission },
  props: {
    address: {
      type: Object,
      required: true,
    },
    value: Boolean,
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showMenu: false,

      dialog: false,
      dialogDelete: false,
      dialogPermissions: false,
    };
  },
  watch: {
    value(v) {
      this.showMenu = v;
    },
    showMenu(v) {
      this.$emit("input", v);
    },
  },
};
</script>
